import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getLaboratoryOrders,
    getPharmacyOrders,
    setLabActiveTile,
    setPharmacyActiveTile
} from '../../../../../redux/actions/dashboard';
import TileItemMobile from './TileItemMobile';
import {getVendorType} from "../../../../../services/auth";

const TopTilesMobile = (props) => {
    const dispatch = useDispatch();
    const {tiles} = props;
    const vendor_type = getVendorType();
    const {lab_active_tile, pharmacy_active_tile} = useSelector((state) => state.dashboard);
    const getActiveTile = () => {
        switch (vendor_type){
            case 'LAB':
                return lab_active_tile;
            case 'HOME_CARE':
                return lab_active_tile;
            case 'DRUG':
                return pharmacy_active_tile;
            default:
                return '';
        }
    };
    const getActiveTileSetter = (name) => {
        switch (vendor_type){
            case 'LAB':
                return setLabActiveTile(name);
            case 'HOME_CARE':
                return setLabActiveTile(name);
            case 'DRUG':
                return setPharmacyActiveTile(name);
            default:
                return setLabActiveTile(name);
        }
    };
    useEffect(() => {
        dispatch(getActiveTileSetter("menu_mobile_lab"))
    }, [])
    return(
        <div className="tiles-holder-mobile">
            {
                tiles.map((tile,index) => {
                    return <TileItemMobile tile={tile} key={index} active={tile.name === getActiveTile()} onClick={() => {
                        dispatch(getActiveTileSetter(tile.name))
                        dispatch(vendor_type === 'DRUG' ? getPharmacyOrders() : getLaboratoryOrders());
                    }} />
                })
            }
        </div>
    )
};

export default TopTilesMobile;